import React, { useEffect } from 'react';
import Avatar from '@strava/ui/Avatar';
import { displayName } from 'utils/general-utils';
import styles from './Welcome.scss';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import OnboardingModalActions from '../../../OnboardingModalActions';
import ActionButton from '../../../ActionButton/ActionButton';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';

const Welcome = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });
  const { currentAthlete, alert } = state;
  const { firstName, avatarUrl, badge } = currentAthlete;

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.welcome),
      action: 'screen_enter'
    });
  }, [track]);

  return (
    <>
      <ModalBodyWithAlerts className={styles.modal} alert={alert}>
        <Avatar
          name={firstName}
          src={avatarUrl}
          badge={badge}
          type="athlete"
          size="xlarge"
          className={styles.avatar}
        />
        <h2 data-cy="welcome">
          {t('consents.welcome.title', {
            athlete_firstname: displayName({ firstName })
          })}
        </h2>
        <p>{t('consents.welcome.subtitle')}</p>
      </ModalBodyWithAlerts>

      <OnboardingModalActions className={styles.modalActions}>
        <ActionButton
          variant="primary"
          onClick={stepForward}
          data-cy="welcome-next-step-btn"
          isProcessing={isProcessing}
        >
          {t('cta_actions.continue')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default Welcome;
